import {createSelector, type Selector} from "@reduxjs/toolkit";
import {omit} from "lodash/fp";

import {type GlobalState as State} from "./memberCustomizationTypes";

import type {MemberCustomization, MemberFlag, MemberFlags} from "../types/app";

const memberCustomizationState = (state: State) => state.memberCustomization;

export const getCustomizationId = (state: State) =>
    memberCustomizationState(state).data.customizationId;

export const getMemberFlags: Selector<State, MemberFlags> = createSelector(
    [memberCustomizationState],
    ({flags}) => omit("_persist", flags),
);

export const getMemberFlag: (flag: MemberFlag) => Selector<State, boolean> = (flag) =>
    createSelector([getMemberFlags], (flags: MemberFlags) => flags[flag]);

export const getMemberCustomization = (state: State): MemberCustomization => ({
    id: getCustomizationId(state),
    flags: getMemberFlags(state),
});
